import React, { useState } from 'react';

const GroupButton = ({ items, onClick, dataTest, disabled }) => {
  const [buttons, setButtons] = useState(items);
  const handleClick = (value) => {
    setButtons(buttons.map((button) => ({ ...button, active: button.label === value })));
    onClick(value);
  };

  return (
    <div className="inline-flex">
      {buttons.map((button, index) => {
        let className =
          'bg-white border-grey-200 border border-solid px-2 py-1 text-xs inline-flex text-grey-400 transition-all disabled:cursor-default';

        if (button.active) {
          className =
            'bg-purple-200 border-purple-200 border border-solid px-2 py-1 text-xs inline-flex text-white transition-all disabled:cursor-default disabled:opacity-50';
        }

        if (index === 0) {
          className = `${className} rounded-l-sm`;
        }

        if (index === buttons.length - 1) {
          className = `${className} rounded-r-sm`;
        }

        return (
          <button
            data-testid={`${dataTest}-${button.label}`}
            key={button.label}
            type="button"
            data-isactive={Boolean(button.active)}
            className={className}
            onClick={() => handleClick(button.label)}
            disabled={disabled}
          >
            {button.label}
          </button>
        );
      })}
    </div>
  );
};

export default GroupButton;
